const LogoffComponent = () => {

    localStorage.clear();
    window.location.href = window.location.origin;
    return null

};

export default LogoffComponent;